import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import Dashboard from 'umg-ember-backend/components/dashboard';
import Window from 'umg-ember-backend/components/ui/window';
import greeting from 'umg-ember-backend/helpers/greeting';

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{greeting @controller.permission.user.person}}
    </:title>

    <:body>
      <Dashboard
        @mlp={{@model.mlp}}
        @domain={{@model.domain}}
        @activities={{@model.activities}}
      />
    </:body>
  </Window>
</template>
